      class ShopListAccordion extends HTMLElement {
        constructor() {
          super();
          this.init();
        }
      
        init() {
          this.triggers = Array.from(this.querySelectorAll('.c-shop-list-accordion__trigger'));
          this.contents = Array.from(this.querySelectorAll('.c-shop-list-accordion__content'));
          
          this.triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => this.toggleAccordion(index));
          });
        }
      
        toggleAccordion(index) {
          const trigger = this.triggers[index];
          const content = this.contents[index];
          const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
          // 現在のアコーディオンのみを切り替え
          trigger.setAttribute('aria-expanded', !isExpanded);
          content.hidden = isExpanded;
        }
      }
      
      customElements.define('shop-list-accordion', ShopListAccordion);